// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_94-0";
export var headerCellHover = "_94-1";
export var readCellContainer = "_94-2";
export var readCellSlot = "_94-3";
export var rowHoverCheckbox = "_94-4";
export var rowUnreadIndicator = "_94-5";
export var searchHighlight = "_94-8";
export var supportTicketRow = "_94-6";
export var unreadIndicator = "_94-7";